import React, { useEffect, useState } from 'react';

export default function ImageViewerModal({ imageUrl, title, subtitle, onClose }) {
  const [zoomMode, setZoomMode] = useState('fit'); // 'fit' | 'actual'

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!imageUrl) return null;

  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.92)',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        backdropFilter: 'blur(8px)',
      }}
      onClick={onClose}
    >
      {/* Top Controls Bar */}
      <div
        style={{
          width: '100%',
          maxWidth: 900,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 14,
          padding: '8px 14px',
          background: 'rgba(15, 23, 42, 0.9)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: 12,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <div style={{ color: '#f8fafc', fontWeight: 700, fontSize: 15 }}>
            {title || 'Image Preview'}
          </div>
          {subtitle && (
            <div className="muted" style={{ fontSize: 12, marginTop: 1 }}>
              {subtitle}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => setZoomMode((m) => (m === 'fit' ? 'actual' : 'fit'))}
            title={zoomMode === 'fit' ? 'View 100% actual size' : 'Fit to screen'}
            style={{ fontSize: 12 }}
          >
            {zoomMode === 'fit' ? '🔍 100% Size' : '📐 Fit Screen'}
          </button>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => window.open(imageUrl, '_blank')}
            title="Open original high-res image in a new browser tab"
            style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}
          >
            ↗ Open in New Tab
          </button>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={onClose}
            style={{ fontWeight: 800, fontSize: 16, padding: '4px 10px' }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Image Container */}
      <div
        style={{
          maxWidth: '92vw',
          maxHeight: '82vh',
          overflow: zoomMode === 'actual' ? 'auto' : 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 12,
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.9)',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          background: '#0a0f1d',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageUrl}
          alt={title || 'Preview'}
          style={{
            maxWidth: zoomMode === 'fit' ? '90vw' : 'none',
            maxHeight: zoomMode === 'fit' ? '80vh' : 'none',
            objectFit: 'contain',
            display: 'block',
            cursor: zoomMode === 'fit' ? 'zoom-in' : 'zoom-out',
          }}
          onClick={() => setZoomMode((m) => (m === 'fit' ? 'actual' : 'fit'))}
        />
      </div>

      <div className="muted" style={{ fontSize: 11, marginTop: 10, color: '#94a3b8' }}>
        Press <kbd style={{ background: '#1e293b', padding: '2px 6px', borderRadius: 4, color: '#fff' }}>Esc</kbd> or click outside to close · Click image to toggle zoom
      </div>
    </div>
  );
}
